export class FormatDate {
  date: Date;

  constructor(dateStr?: string) {
    this.date = dateStr ? new Date(dateStr) : new Date();
  }

  toString() {
    const day = this.date.getUTCDate();
    const month = this.date.getUTCMonth() + 1;
    const year = this.date.getUTCFullYear();
    const hour = this.date.getUTCHours();
    const minute = this.date.getUTCMinutes();
    const second = this.date.getUTCSeconds();

    return (
      year +
      "-" +
      this._toDigit(month, 2) +
      "-" +
      this._toDigit(day, 2) +
      "T" +
      this._toDigit(hour, 2) +
      ":" +
      this._toDigit(minute, 2) +
      ":" +
      this._toDigit(second, 2)
    );
  }

  private _toDigit(n: number, digit: number) {
    return ("00" + n).slice(-1 * digit);
  }
}
